import { useEffect } from 'react';

export default function MainScripts() {
  useEffect(() => {
    // Load main frontend JS files dynamically
    const loadJS = (src, id) => {
      // Remove existing script if it exists to force reload
      const existingScript = document.getElementById(id);
      if (existingScript && existingScript.parentNode) {
        existingScript.parentNode.removeChild(existingScript);
      }

      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    };

    // Load JS files (Font Awesome JS removed – we only use CSS icons)
    // Use absolute paths (starting with /) to work from any route
    const jsFiles = [
      { src: '/js/jquery-3.5.1.min.js', id: 'main-jquery-js' },
      { src: '/js/bootstrap.min.js', id: 'main-bootstrap-js' },
      { src: '/js/particles.js', id: 'main-particles-js' },
      { src: '/js/particlerun.js', id: 'main-particlerun-js' },
      { src: '/js/plugin.js', id: 'main-plugin-js' },
      { src: '/js/main.js', id: 'main-main-js' },
      {
        src: 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.js',
        id: 'main-swiper-js',
        integrity: 'sha512-Ysw1DcK1P+uYLqprEAzNQJP+J4hTx4t/3X2nbVwszao8wD+9afLjBQYjz7Uk4ADP+Er++mJoScI42ueGtQOzEA==',
        crossOrigin: 'anonymous',
      },
      { src: '/js/custom-nav.js', id: 'main-custom-nav-js' },
    ];

    // Initialize main frontend functionality after scripts load
    const initializeMainFrontend = () => {
      // Remove dashboard-specific body classes
      document.body.classList.remove('sidebar-toggle', 'sidebar-mini', 'sidebar-collapse');
      
      // Re-initialize any custom navigation or other frontend features
      if (window.jQuery && window.jQuery.fn) {
        // Re-initialize any jQuery plugins if needed
        try {
          // Trigger any initialization functions that might be in main.js
          if (typeof window.initMainFrontend === 'function') {
            window.initMainFrontend();
          }
        } catch (e) {
          console.log('Main frontend initialization:', e);
        }
      }
    };

    // Load JS files sequentially
    let jsIndex = 0;
    const loadNextJS = () => {
      if (jsIndex < jsFiles.length) {
        const file = jsFiles[jsIndex];
        const script = loadJS(file.src, file.id);
        if (file.integrity) {
          script.integrity = file.integrity;
        }
        if (file.crossOrigin) {
          script.crossOrigin = file.crossOrigin;
        }
        script.onload = () => {
          jsIndex++;
          if (jsIndex === jsFiles.length) {
            // All scripts loaded, initialize frontend
            setTimeout(initializeMainFrontend, 100);
          }
          loadNextJS();
        };
        script.onerror = () => {
          jsIndex++;
          if (jsIndex === jsFiles.length) {
            // All scripts attempted, try to initialize anyway
            setTimeout(initializeMainFrontend, 100);
          }
          loadNextJS();
        };
      }
    };
    loadNextJS();

    // Cleanup function
    return () => {
      jsFiles.forEach((file) => {
        const script = document.getElementById(file.id);
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return null;
}
